import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'hooks/useTranslation'
import { 
  BestRoot, 
  BadgeWrapper, 
  ContentWrapper, 
  Title, 
  Subtitle 
} from './Best.styles';
import badge from '../../../../../../../../public/assets/recipes/categories/meet-our-meats-badge.png'

export const Best: React.FC = () => {
  const { t } = useTranslation('products');

  return (
    <BestRoot>
      <BadgeWrapper>
        <Image src={badge} alt={t('products:essentials.bestSelling.badgeAlt')} layout="fill" objectFit="contain" />
      </BadgeWrapper>
      <ContentWrapper>
        <Subtitle>{t('products:essentials.bestSelling.title')}</Subtitle>
        <Title>{t('products:essentials.bestSelling.subtitle')}</Title>
      </ContentWrapper>
    </BestRoot>
  );
};